import { render, staticRenderFns } from "./textCoverCom.vue?vue&type=template&id=ea2dc96e&scoped=true"
import script from "./textCoverCom.vue?vue&type=script&lang=js"
export * from "./textCoverCom.vue?vue&type=script&lang=js"
import style0 from "./textCoverCom.vue?vue&type=style&index=0&id=ea2dc96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2dc96e",
  null
  
)

export default component.exports